import { render, staticRenderFns } from "./chongq.vue?vue&type=template&id=63c17bee&"
import script from "./chongq.vue?vue&type=script&lang=js&"
export * from "./chongq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports